import React from 'react';
import css from './movieDetail.module.css';
type Props = {
    data?:{
        img:string,
        titulo?:string,
        id?:number
    }
}
const MovieDetail: React.FC<Props> = ({data}) => {
    return(
        <div className={css.div}>
            <a href={data?.img} target="_blank" rel="noreferrer">
                <img src={data?.img} alt="Poster"/>
            </a>
            <p>
                <a href={data?.img} target="_blank" rel="noreferrer">{data?.titulo}</a>
            </p>
        </div>
    )
}
export {MovieDetail}